import { z } from 'zod';

import { timestamp } from '../formatTimestamp';
import { isTimeInput } from '../time';

export const zodStringRequired = () => z.string().min(1);
export const zodStringNullable = () => z.string().nullable();
export const zodStringNullish = () => z.string().nullish();

export const zodNumberNullable = () => z.coerce.number().nullable();
export const zodNumberNullish = () => z.coerce.number().nullish();

export const zodBooleanNullable = () => z.boolean().nullable();

/**
 * A nullable wall-clock time field. Validity is delegated to `isTimeInput` so the accepted
 * input forms cannot drift apart from `parseTimeInput`, which normalizes the field on blur.
 */
export const zodTimeString = (message: string) => z.string().nullable().refine(isTimeInput, { message });

export const zodMoment = () =>
    z.unknown().transform((val) => {
        if (typeof val !== 'string' && typeof val !== 'number') throw new Error(`Invalid type for date: ${typeof val}`);
        const date = timestamp(val);
        if (!date?.isValid()) throw new Error(`Invalid date: ${val}`);

        return date;
    });
